import axios from 'axios';

// Same-origin by default. frontend/nginx.conf proxies /api to the gateway, so
// a relative base works in production and survives a domain change without a
// rebuild. The previous localhost:3100 default shipped into the production
// bundle and made the browser call the user's own machine, which fails CORS.
// Set REACT_APP_API_URL to an absolute origin only for local dev against a
// gateway on another port.
const BASE = process.env.REACT_APP_API_URL || '';

export async function getMillingDashboard(days = 30) {
  const res = await axios.get(`${BASE}/api/v1/milling/analytics/dashboard`, { params: { days } });
  return res.data;
}
